//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Popconfirm,
  Table,
  Button,
  Input,
  Form,
  Modal,
  Checkbox,
  Row,
  Col,
  Tooltip,
  Collapse,
  ConfigProvider,
  Divider,
  Radio,
} from "antd";
import { PlusOutlined, EditOutlined, HistoryOutlined, DownloadOutlined, UserAddOutlined, FilterOutlined } from "@ant-design/icons";
import IDynamicTable from "./IDynamicTable";
import {
  BsColumns,
  BsPinAngle,
  BsPinAngleFill,
  BsPinFill,
  BsThreeDotsVertical,
} from "react-icons/bs";
import TableFilters from "./TableFilters";
import { FaFilter } from "react-icons/fa6";
import Panel from "antd/es/splitter/Panel";
import "../../App.css";
import { useNavigate, useLocation } from "react-router-dom";
import type { TableColumnsType, TableProps } from "antd";
import Item from "antd/es/list/Item";
import EmployeeTabs from "../../Pages/EmployeeTabs/Employeetabs";

const FormTable = ({
  columns = [],
  isAddRowTable = false,
  name,
  dataSource = [],
  onChange,
  keyIdentity = null,
  filters,
  form,
  isReset = false,
  setIsReset = null,
  dashboardId = 0,
  handleButtonClick = () => { },
  handleNavigation = () => { },
  field = {},
  fields = [],
  section = {},
  tableCheckbox,
  showSearchInput,
  handleSearch,
  pageButtons,
  handlePageActionClick,
  loadingState,
  setLoadingState,
  ...rest
}: any) => {
  const [data, setData] = useState([]);

  const [editingKey, setEditingKey] = useState<string>("");
  const [tempData, setTempData] = useState({});

  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [gridColumns, setGridColumns] = useState<any[]>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location || {};
  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  useEffect(() => {
    //console.log("columns updated:", columns);
    if (columns && columns.length > 0) {
      setUpdatedColumns([...columns]);
      setVisibleColumns(
        [...columns].map((data) => {
          return data.dataIndex;
        })
      );
    }
  }, [columns]);

  useEffect(() => {
  //  console.log("dataSource useeffect:", dataSource);
    if (columns && columns.length > 0) {
      setData([...dataSource]);
    }
  }, [dataSource]);

  const [isVisibleColumnsModalVisible, setVisibleColumnsModalVisible] =
    useState(false);
  const [visibleColumnsModalSearchText, setVisibleColumnsModalSearchText] =
    useState<string>(""); // State for search input
  const [isFiltersVisible, setFiltersVisible] = useState<boolean>(false);

  useEffect(() => {
    // Whenever the data state changes, update the 'addedRows' field in the form
    // debugger;
    form?.setFieldValue(name, data);
    console.log();
    const allFields = form?.getFieldsValue();
    console.log("all Fields", allFields);
  }, [data]);

  // useEffect(() => {
  //   if (isReset) {
  //     setData([]);
  //     setIsReset(false);
  //   }
  // }, [isReset]);

  // useEffect(() => {
  //   // Initialize columns when props.columns change
  //   const newColumns = columns.map((column: any) => {
  //     const isPinnedNew = column?.isPin;

  //     if (isPinnedNew) {
  //       if (column?.sorter) {
  //         //column.minWidth = 150;
  //       }
  //       column.filterDropdown = ({
  //         setSelectedKeys,
  //         selectedKeys,
  //         confirm,
  //         clearFilters,
  //       }: any) => (
  //         <div
  //           style={{
  //             display: "flex",
  //             flexDirection: "column",
  //             justifyContent: "space-evenly",
  //             alignItems: "flex-start",
  //             padding: 5,
  //           }}
  //         >
  //           {selectedKeys.includes("Pin") ? (
  //             <Button
  //               block
  //               type="text"
  //               className="btn"
  //               onClick={() => {
  //                 const newSelectedKeys = selectedKeys.filter(
  //                   (item: any) => item !== "Pin"
  //                 );
  //                 setSelectedKeys(newSelectedKeys);
  //                 confirm();
  //               }}
  //             >
  //               <BsPinAngleFill color="blue" /> Unpin
  //             </Button>
  //           ) : (
  //             <Button
  //               block
  //               type="text"
  //               className="btn"
  //               onClick={() => {
  //                 setSelectedKeys([...selectedKeys, "Pin"]);
  //                 confirm();
  //               }}
  //             >
  //               <BsPinAngle /> Pin
  //             </Button>
  //           )}

  //           <Button
  //             block
  //             type="text"
  //             className="btn"
  //             onClick={() => {
  //               handleManageColumns();
  //               confirm();
  //             }}
  //           >
  //             <BsColumns /> Manage Columns
  //           </Button>
  //         </div>
  //       );

  //       column.filterIcon = (filtered: any) => (
  //         <BsThreeDotsVertical
  //           style={{
  //             color: filtered ? "blue" : "black",
  //             fontSize: "18px",
  //           }}
  //         />
  //       );

  //       column.filters?.push({
  //         text: (
  //           <span>
  //             <BsPinFill style={{ color: "#1890ff" }} />
  //             Pin
  //           </span>
  //         ),
  //         value: "Pin",
  //       });
  //     }

  //     column.title = (
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "space-between",
  //           //width: "100%",
  //         }}
  //       >
  //         {column.title}
  //       </div>
  //     );

  //     if (column.sort) {
  //       column.sorter = (a: any, b: any) => {
  //         if (a[column.dataIndex] < b[column.dataIndex]) {
  //           return -1;
  //         }
  //         if (a[column.dataIndex] > b[column.dataIndex]) {
  //           return 1;
  //         }
  //         return 0;
  //       };
  //     }

  //     return column;
  //   });

  //   setUpdatedColumns(newColumns);

  //   let dumpData = {};
  //   if (columns && columns.length > 0) {
  //     for (let index = 0; index < columns.length; index++) {
  //       const column: any = columns[index];
  //       if (
  //         !column?.element ||
  //         (column?.element && column?.element.toLowerCase() == "field")
  //       ) {
  //         dumpData = { ...dumpData, [column.key]: "" };
  //       }
  //     }
  //     setTempData(dumpData);
  //   }
  // }, [columns]);

  const isEditing = (record: any) => record.key === editingKey;

  const edit = (record: any) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  // const save = async (
  //   key: string,
  //   value: any,
  //   dataIndex: string,
  //   form: any
  // ) => {
  //   try {
  //     if (!value) {
  //       return;
  //     }
  //     const newData = [...data];
  //     const index = newData.findIndex((item) => key === item.key);
  //     if (index > -1) {
  //       newData[index][dataIndex] = value;
  //       setData(newData);
  //     }
  //   } catch (errInfo) {
  //     console.log("Validate Failed:", errInfo);
  //   }
  // };

  // const handleAdd = () => {
  //   const newRow = columns.reduce((acc: any, column: any) => {
  //     if (column?.element?.toLowerCase() === "field") {
  //       acc[column.name] = "";
  //     }
  //     return acc;
  //   }, {});

  //   // debugger;
  //   newRow.key = `${data.length + 1}`; // Unique key for new row
  //   (newRow.isNew = true), setData([...data, newRow]); // Add new row
  //   // debugger;
  //   // setRow(row + 1); // Increment row counter
  // };

  // const handleDelete = (key: string) => {
  //   setData(data.filter((item) => item.key !== key));
  // };

  // const actionColumn = {
  //   title: "Action",
  //   key: "action",
  //   render: (_: any, record: any) => {
  //     const editable = isEditing(record);
  //     // return editable ? (
  //     //   <span>
  //     //     <Button
  //     //       onClick={() => save(record.key)}
  //     //       style={{ marginRight: 8 }}
  //     //       type="link"
  //     //     >
  //     //       Save
  //     //     </Button>
  //     //     <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
  //     //       <Button type="link">Cancel</Button>
  //     //     </Popconfirm>
  //     //   </span>
  //     // ) : (
  //     //   <span>
  //     //     <Button
  //     //       disabled={editingKey !== ""}
  //     //       onClick={() => edit(record)}
  //     //       type="link"
  //     //     >
  //     //       Edit
  //     //     </Button>
  //     //     <Popconfirm
  //     //       title="Sure to delete?"
  //     //       onConfirm={() => handleDelete(record.key)}
  //     //     >
  //     //       <Button type="link" danger>
  //     //         Delete
  //     //       </Button>
  //     //     </Popconfirm>
  //     //   </span>
  //     // )

  //     if (columns && columns.length > 0) {
  //       for (let index = 0; index < columns.length; index++) {
  //         const col: any = columns[index];
  //         if (col && col?.element?.toLowerCase() == "action") {
  //           return (
  //             col?.actionButtons &&
  //             col?.actionButtons?.map((ab: any) => {
  //               if (ab.toLowerCase() == "delete") {
  //                 return (
  //                   <span>
  //                     <Popconfirm
  //                       title="Sure to delete?"
  //                       onConfirm={() => handleDelete(record.key)}
  //                     >
  //                       <Button type="link" danger>
  //                         Delete
  //                       </Button>
  //                     </Popconfirm>
  //                   </span>
  //                 );
  //               } else if (ab.toLowerCase() == "edit") {
  //                 return (
  //                   <span>
  //                     <Button
  //                       disabled={false}
  //                       onClick={() => edit(record)}
  //                       type="link"
  //                     >
  //                       Edit
  //                     </Button>
  //                   </span>
  //                 );
  //               }
  //             })
  //           );
  //         }
  //       }
  //     }
  //   },
  // };
  // Added ne action column
  // Define the action column
  const actionColumn = {
    title: "Action",
    dataIndex: "action",
    key: "action",
    fixed: "right",
    width: 100,
    render: (_, record) => (
      <Tooltip>
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEdit(record)}
          title="Edit"
        />
        <Button
          type="link"
          icon={<HistoryOutlined />}
          onClick={() => handleEdit(record)}
          title="History"
        />
      </Tooltip>
    ),
  };

  const handleEdit = (record) => {
    setEditingKey(record.Key); // Set row as editable
    // form.setFieldsValue({ ...record }); // Populate form with row data
    navigate("/DynamicFormComponent", {
      state: {
        id: record.interfaceId,
        actionType: "Edit",
        RId: record.Key,
        Mode: "Edit",
      },
    });
  };
  const mergedColumns = updatedColumns
    .map((col: any) => {
      //console.log("col.editable: ", col.editable);
      // if (!col.editable) {
      //   return col;
      // }
      return {
        ...col,
        onCell: (record: any, index: number) => {
          //console.log("col: ", col.type, col.rowSpan);
          //console.log("dddd index: ", col.title, index);
          let onCellObj = {
            record,
            //inputType: col.dataIndex === "age" ? "number" : "text",
            inputType: col.type,
            dataIndex: col.dataIndex,
            title: col.title,
            editing: col.isFieldEditable ?? isEditing(record),
          };
          if (col.rowSpan) {
            const rowSpanStart =
              col.rowSpanStart && col.rowSpanStart > 0
                ? col.rowSpanStart - 1
                : 0;

            const rowSpanEnd =
              col.rowSpanEnd && dataSource.length >= col.rowSpanEnd
                ? col.rowSpanEnd
                : dataSource.length;

            if (index === rowSpanStart) {
              onCellObj = {
                ...onCellObj,
                rowSpan: rowSpanEnd - rowSpanStart,
              }; // Apply rowspan to the first row
            } else if (index > rowSpanStart && index <= rowSpanEnd) {
              onCellObj = { ...onCellObj, rowSpan: 0 };
            }
          }
          if (col.colSpan) {
            const colSpanStart =
              col.colSpanStart && col.colSpanStart > 0
                ? col.colSpanStart - 1
                : 0;
            const SpanEnd =
              col.colSpanEnd && dataSource.length >= col.colSpanEnd
                ? col.colSpanEnd
                : dataSource.length;

            if (index === colSpanStart) {
              onCellObj = {
                ...onCellObj,
                colSpan: SpanEnd - colSpanStart,
              }; // Apply rowspan to the first row
            } else if (index > colSpanStart && index <= SpanEnd) {
              onCellObj = { ...onCellObj, colSpan: 0 };
            }
          }
          return onCellObj;
        },
      };
    })
    .filter((column: any) => visibleColumns.includes(column.dataIndex));
  //.concat(actionColumn);

  // const newupdatedColumns = [...mergedColumns, actionColumn];
  const newupdatedColumns = [...mergedColumns];

  const EditableCell: React.FC<any> = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    children,
    ...restProps
  }) => {
    //const inputNode = inputType === "number" ? <Input type="number" /> : <Input />;
    const [form1] = Form.useForm();
    // const inputNode =
    //   inputType === "number" ? <Input type="number" /> : <Input />;
      const inputNode = inputType ? ( inputType === "number" ? <InputNumber /> : <Input />) : <Input />;

    // console.log(
    //   "dataIndex",
    //   dataIndex,
    //   "title",
    //   title,
    //   "keyIdentity",
    //   keyIdentity
    // );

    const inputRef = React.useRef<any>(null); // Local ref for the input element
    return (
      <td {...restProps}>
        <Form form={form1} component={false}>
          {editing ? (
            <Form.Item
              name={dataIndex}
              style={{ margin: 0 }}
              rules={[
                {
                  required: true,
                  message: `Please Input ${title}!`,
                },
                {
                  validator: async (_: any, value: any) => {
                    if (dataIndex === "age" && isNaN(value)) {
                      return Promise.reject(
                        new Error("Age should be a number")
                      );
                    }
                    if (dataIndex === "age" && value <= 15) {
                      return Promise.reject(new Error("Age should be > 15"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              {React.cloneElement(inputNode, {
                ref: inputRef,
                defaultValue: record[dataIndex],
                onBlur: (e: any) => {
                  save(record.key, e.target.value, dataIndex, form1);
                },

                onMouseEnter: () => {
                  // Optionally, highlight the input field when hovered
                  inputRef.current.focus();
                },
              })}
            </Form.Item>
          ) : (
            children
          )}
        </Form>
      </td>
    );
  };
  const handleTableChange = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any
  ) => {
    const newColumns = updatedColumns.map((column: any) => {
      const isPinned =
        filters[column.key] && filters[column.key].includes("Pin");

      column.filterIcon = (filtered: any) => (
        <div
          style={{ display: "flex", justifyContent: "space-between", gap: 3 }}
        >
          {isPinned && (
            <div style={{ position: "relative" }}>
              <BsPinAngleFill
                color="blue"
                style={{
                  position: "absolute",
                  top: 2,
                  right: -4,
                  fontSize: "10px",
                }}
              />
            </div>
          )}
          <BsThreeDotsVertical
            style={{
              color: filtered ? "blue" : "black",
              fontSize: "18px",
            }}
          />
        </div>
      );

      return {
        ...column,
        fixed: isPinned ? true : undefined,
      };
    });

    setUpdatedColumns(newColumns);
    onChange?.(pagination, filters, sorter, extra);
  };

  // Handle opening the column management modal
  const handleManageColumns = () => {
    setVisibleColumnsModalVisible(true);
  };

  // Handle closing the modal
  const handleCancel = () => {
    setVisibleColumnsModalSearchText("");
    setVisibleColumnsModalVisible(false);
  };

  // Handle column visibility toggle
  const handleColumnToggle = (columnKey: string, checked: boolean) => {
    setVisibleColumns((prevVisibleColumns) =>
      checked
        ? [...prevVisibleColumns, columnKey]
        : prevVisibleColumns.filter((key) => key !== columnKey)
    );
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //console.log(e.target.value);
    setVisibleColumnsModalSearchText(e.target.value);
  };

  // Filter columns based on search text using regex
  const filteredColumns = updatedColumns.filter((column: any) => {
    // Ensure column.title is a string before applying regex
    // console.log("column", column.dataIndex);

    try {
      // Create a case-insensitive regex from the search text
      const regex = new RegExp(visibleColumnsModalSearchText, "i"); // 'i' for case-insensitive matching
      //console.log("Search Text:", searchText);

      // Use regex test to check if the searchText matches the column title
      return regex.test(column.key);
    } catch (e) {
      // If the searchText is not a valid regex, fall back to default behavior (e.g., case-insensitive match)
      console.error("Invalid Regex", e, column.key);
      return column.key;
    }
  });

  // console.log("filtered Column", filteredColumns);

  // Render the column visibility management modal
  const renderColumnVisibilityModal = () => (
    <Modal
      title="Manage Columns"
      visible={isVisibleColumnsModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={300} // Adjust the width of the modal
      style={{
        maxHeight: "400px", // Medium height for the modal
        // Enable scrolling for content inside the modal
      }}
    >
      <div>
        {/* Search input field */}
        <Input
          placeholder="Search Columns"
          value={visibleColumnsModalSearchText}
          onChange={handleSearchChange}
          style={{ marginBottom: 15 }}
        />

        {/* Scrollable list of checkboxes */}
        <div style={{ maxHeight: 300, overflowY: "auto" }}>
          {filteredColumns.map((column: any) => (
            <div key={column.key} style={{ marginBottom: 10 }}>
              <Checkbox
                checked={visibleColumns.includes(column.key)}
                onChange={(e) =>
                  handleColumnToggle(column.key, e.target.checked)
                }
              >
                {column.title}
              </Checkbox>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={handleCancel}>Close</Button>
        </div>
      </div>
    </Modal>
  );

  useEffect(() => {
    // const keys = data.map(item => item.key);
    // console.log(keys);
    console.log(
      "bsbabd L:::::: ",
      data.map((Item) => Item.Key)
    );
  }, []);

  //console.log("data:::", data);
  //console.log("dataSource:::", dataSource);

  // For the row selection.
  const rowSelection: TableProps<DataType>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record: DataType) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
  };
  return (
    <><Form form={form} component={false} style={{ width: "100%" }}>
      {renderColumnVisibilityModal()}
      {isAddRowTable ? (
        <Row gutter={16}>
          <Col span={16}>
            {/* <Button
              onClick={handleAdd}
              type="primary"
              style={{ marginBottom: 16 }}
              icon={<PlusOutlined />}
            >
              Add Row
            </Button> */}
          </Col>
          {dashboardId != 0 && (<Col xs={24} sm={24} md={24} className="filterBtn d-md-flex d-sm-block justify-content-end gap-3">
            {/* <Button
              className="createBtn"
              type="primary"
            >
              <UserAddOutlined /> Add User
            </Button> */}
            {/*<Button
              className="createBtn"
              type="primary"
              onClick={() => handleNavigation(state?.id, "Create", 0)}
            >
              Create
            </Button>*/}
            <div className="d-flex gap-2 justify-content-end">
                          {pageButtons?.map((button: any, index: number) => {
                            return (
                              <Button
                                key={index}
                                //type="primary"
                                onClick={() => handlePageActionClick(button)}
                                loading={loadingState[button.label]}
                                disabled={loadingState[button.label]}
                                className={
                                  button.actionType.toLowerCase() ===
                                  "dynamicreportactioncreate"
                                    ? "createBtn"
                                    : button.actionType.toLowerCase() ===
                                      "dynamicreportactionexporttoexcel"
                                    ? "btn-export"
                                    : ""
                                }
                              >
                                {button.label}
                              </Button>
                            );
                          })}
                        </div>
            <div className="mob-view">
            {showSearchInput && (
              <Input
                placeholder="Search..."
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 200 }} />
            )}
              {/* <Button
                className="downloadIcon"
                variant="text"
              >
                <DownloadOutlined />
              </Button> */}
              {filters?.fields?.length > 1 && (
                <>
                  <Tooltip title="Filter">
                      <Button
                        className="filtIcon"
                        variant="text"
                        icon={<FilterOutlined />}
                        onClick={() => {
                          setFiltersVisible(!isFiltersVisible);
                        }} />
                  </Tooltip>
                </>
              )}
            </div>
          </Col>)
          }
        </Row>
      ) : null}
      <Form.Item name={name} hidden>
        <Input />
      </Form.Item>
      {filters && (
        <ConfigProvider
          theme={{
            components: {
              Collapse: {
                headerPadding: undefined,
              },
            },
          }}
        >
          <Collapse
            activeKey={isFiltersVisible ? "1" : undefined}
            bordered={false}
            expandIcon={() => null}
            ghost
            className="filterContent"
            items={[
              {
                key: 1,
                collapsible: "disabled",
                showArrow: false,
                forceRender: true,
                children: (
                  <Row>
                    <TableFilters
                      config={filters}
                      handleButtonClick={handleButtonClick}
                      isReset={true}
                      dashboardId={dashboardId}
                    />
                  </Row>
                ),
              },
            ]}
          />
        </ConfigProvider>
      )}
      <div className="tableBg mt-3">
        <Table
	{...(tableCheckbox && {
          rowSelection: {
            ...(section?.rowSelection ?? { type: "checkbox" }),
            ...rowSelection,
          },
        })}
          //rowSelection={rowSelection}
          rowSelection= {dashboardId == 6  ? { type: "checkbox", ...rowSelection } : undefined }
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          scroll={{ x: "max-content" }}
          bordered
          dataSource={data}
          columns={newupdatedColumns}
          rowClassName="editable-row"
          style={{ width: "100%" }}
          onChange={handleTableChange}
          pagination={{
            onChange: cancel,
            position: [isAddRowTable ? "none" : "bottomRight"],
          }}
          {...rest} />
      </div>
    </Form>
      {/* <EmployeeTabs></EmployeeTabs> */}
    </>
  );
};

export default FormTable;
